<template>
  <div>
    <list
      ref="list"
      unit="费用分摊单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商名称">
         <supplier  @restaurants='setSupplier' :state='params.SupplierName'/>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.OrderNo" placeholder="请输入单据编号" />
        </el-form-item>
                <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分摊方式">
          <el-select size="mini" v-model="params.ShareWay" placeholder="请选择" clearable>
            <!-- <el-option label="草稿" :value="0"></el-option> -->
            <el-option label="按金额" :value="1"></el-option>
            <el-option label="按费用类型" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="OrderNo" label="单据类型"/> -->
        <el-table-column prop="DocNo" label="单据编号" min-width="110px">
          <template slot-scope="{row}">
            {{row.DocDate.split(" ")[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{ row }">
            {{ row.DocDate.split(" ")[0] }}
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="分摊方式">
          <template slot-scope="{row}">
            <!-- <span v-if="row.Status==0">草稿</span> -->
            <span v-if="row.Status==1">按金额</span>
            <span v-else>按费用类型</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" title="客户列表" :typeList="[1,2]" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import supplier from "@/components/common/supplier/supplier";
export default {
  mixins: [listMixin],
  components: { list,unitDialog,supplier },
  beforeMount() {
    this.cApi.list({ pageSize: 100, pageIndex: 1 }).then(res => {
      this.cList = res.Data
      sessionStorage.setItem("cList",JSON.stringify(res.Data))
    })
  },
  mounted() {
    this.dpapi.list({}).then(res => {
        let list=[]
        res.Data.forEach(e => {
          list.push( { "value": e.SupplierName, "Id": e.SupplierId },)
        });
        this.supplierList=list
      })
  },
  data() {
    return {
      api: require("@/api/purchase/splitbill").default,
      cApi: require("@/api/ba/tradeUnit").default,
      dpapi: require("@/api/ba/tradeUnit").default,
      cList: [],
      supplierList:[],
      params: {
        DocType: 1,
        DocNo: "",
        SupplierId: null,
        SupplierName: "",
        DocDateStart: "",
        DocDateEnd: "",
        ShareWay: null,
        OutStatus: null,
        WarehouseName: "",
        //----------
        pageIndex: 10,
      },
    };
  },
  methods: {
    setSupplier(data) {
        
        this.params.SupplierId = data.TradeUnitId;
        this.params.SupplierName = data.TradeUnitName;
    },
    handleSelect(item) {
        
        this.params.SupplierName=item.value
        this.params.SupplierId=item.Id
      },
      querySearchAsync(queryString, cb) {
        var supplierList = this.supplierList;
        var results = queryString ? supplierList.filter(this.createStateFilter(queryString)) : supplierList;
        cb(results);
      },
      createStateFilter(queryString) {
        return (state) => {
          if(state.value){
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          }
        };
      },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.params.SupplierId = e.Id
      this.params.SupplierName = e.Name
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>